<template>
  <div class="briefs-tareas-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroPeriodo="filtroPeriodo"
          :filtroBrief="filtroBrief"
          :filtroPresupuesto="filtroPresupuesto"
          :fechaDesde="new Date(fechaDesde)"
          :fechaHasta="new Date(fechaHasta)"
          :cliente="cliente"
          :estado="estado"
          :prioridad="prioridad"
          :usuario="usuario"
          :briefId="parseInt(briefId)"
          :presupuestoNumero="parseInt(presupuestoNumero)"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Tareas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="briefsTareas" 
              :fields="fields"> 
              <!-- @row-clicked="consultar"> -->
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaEntrega)="data">
                {{ data.item.fechaEntrega | fecha }}
            </template>
            <template v-slot:cell(prioridad)="data">
              <b-badge 
                  :variant="getBadgePrioridad(data.item)">
                {{ data.item.prioridad }}
              </b-badge>
            </template>
            <template v-slot:cell(briefTareaEstado)="data">
              <b-badge 
                  :style='"background-color: " + data.item.briefTareaEstadoColor + ";color: " + data.item.briefTareaEstadoFontColor + ";"'>
                {{ data.item.briefTareaEstado }}
              </b-badge>
            </template>

            <!-- <template v-slot:cell(finalizado)="data">
              {{ (data.item.finalizado) ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template> -->

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="consultarBrief(data.item.briefId)">
                  <i class="fa fa-folder"></i>Consultar Brief</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefsTareas/getField',
  mutationType: 'briefsTareas/updateField',
});

export default {
  name: 'BriefsTareasList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'briefId',
          label: 'Nro.Brief',
          sortable: true
        },
        {
          key: 'titulo',
        },
        {
          key: 'usuario',
          label: 'Responsable',
          class: 'text-center'
        },
        // {
        //   key: 'usuarioIniciales',
        //   label: 'Responsable',
        //   class: 'text-center'
        // },
        {
          key: 'briefTareaEstado',
          label: 'Estado',
          // sortable: true
        },

        {
          key: 'fechaEntrega',
          label: 'Entrega',
          // sortable: true
        },
        {
          key: 'prioridad',
          // sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'briefsTareas',
      'briefsTareasEstados',
      'filtroPeriodo',
      'filtroBrief',
      'filtroPresupuesto',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'estado',
      'prioridad',
      'usuario',
      'briefId',
      'presupuestoNumero',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.filtroPeriodo = filtro.filtroPeriodo;
      this.filtroBrief = filtro.filtroBrief;
      this.filtroPresupuesto = filtro.filtroPresupuesto;
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.cliente = filtro.cliente;
      this.estado = filtro.estado;
      this.prioridad = filtro.prioridad;
      this.usuario = filtro.usuario;
      this.briefId = parseInt(filtro.briefId);
      this.presupuestoNumero = parseInt(filtro.presupuestoNumero);
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('briefsTareas/getBriefsTareas')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    // consultar (item) {
    //   this.$router.push({ name: 'BriefTareaData', 
    //                       params: { id: item.id }})
    // },
    consultarBrief (briefId) {
      this.$router.push({ name: 'BriefData', 
                          params: { id: briefId }});
    },
    getBadgePrioridad(item) {
      switch (item.prioridadId) {
        case 1: //Urgente
          return 'danger';
        case 2: //Alta
          return 'danger';
        case 3: //Normal
          return 'warning';
        case 4: //Baja
          return 'success';
        default:
          return '';
      }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
  .briefs-tareas-list .registro table td[aria-colindex="1"] {
    width: 15px;
  }
  .briefs-tareas-list .registro table td[aria-colindex="2"] {
    width: 8%;
  }
  .briefs-tareas-list .registro table td[aria-colindex="3"] {
    width: calc(36% - 45px);
  }
  .briefs-tareas-list .registro table td[aria-colindex="4"] {
    width: 20%;
  }
  .briefs-tareas-list .registro table td[aria-colindex="5"] {
    width: 12%;
  }
  .briefs-tareas-list .registro table td[aria-colindex="6"] {
    width: 12%;
  }
  .briefs-tareas-list .registro table td[aria-colindex="7"] {
    width: 12%;
  }
  .briefs-tareas-list .registro table td[aria-colindex="8"] {
    width: 30px;
  }

  .briefs-tareas-list .registro span.badge {
    /* font-size: 1em;
    font-weight: normal; */
    width: 95%;
    padding: 5px;
    font-weight: 400;
  }

  .briefs-tareas-list .registro .btn.detailShowing {
    position: relative;
    top: -5px;
  }
  .briefs-tareas-list .registro .b-table-details td {
    padding-top: 0;
    padding-bottom: 15px;
    padding-left: 30px;
  }
  .briefs-tareas-list .registro .b-table-details td p {
    margin-bottom: 0;
    white-space: pre-line;
  }
</style>
